type KeycloakParsedToken = Object & {
  given_name: string;
  family_name: string;
  email: string;
  customerId: number;
};

type KeycloakParsedTokenKey = keyof KeycloakParsedToken;

export class AuthTokenData {
  private readonly keycloakTokenParsed: KeycloakParsedToken;
  readonly token: string;

  constructor(keycloakTokenParsed: KeycloakParsedToken, token: string) {
    this.keycloakTokenParsed = keycloakTokenParsed;
    this.token = token;
  }

  private getValueFromToken(key: KeycloakParsedTokenKey) {
    return this.keycloakTokenParsed?.[key];
  }

  get customerFirstName(): string {
    return this.getValueFromToken('given_name') as string;
  }

  get customerLastName(): string {
    return this.getValueFromToken('family_name') as string;
  }

  get customerEmail(): string {
    return this.getValueFromToken('email') as string;
  }

  get customerId(): number {
    return this.getValueFromToken('customerId') as number;
  }
}
